import { Directive, ElementRef, HostListener, Input } from '@angular/core';
//The trim directive will eliminate leading and trailing spaces and also set the max character limit for the input
@Directive({
  selector: '[Trim]',
  standalone: true,
})
export class TrimDirective {
  constructor(private el: ElementRef) {}
  @HostListener('input', ['$event']) onInputChange(event: any) {
    let initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue.replace(/\s/g, '');
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
